import { motion } from 'framer-motion';
import { Shield, Users, BadgeCheck, Clock, Award, MessageCircle } from 'lucide-react';
import { diferenciais } from '../lib/siteConfig';

const iconMap = {
  Shield: Shield,
  Users: Users,
  BadgeCheck: BadgeCheck,
  Clock: Clock,
  Award: Award,
  MessageCircle: MessageCircle,
};

export const Differentials = () => {
  return (
    <section
      id="diferenciais"
      className="py-20 lg:py-28 bg-[#0F0F0F]"
      data-testid="differentials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="inline-block text-[#FF6B00] font-semibold uppercase tracking-wider text-sm mb-4">
            Por que nos escolher
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Nossos <span className="text-[#FF6B00]">Diferenciais</span>
          </h2>
          <p className="text-lg text-[#999]">
            Compromisso com qualidade, segurança e satisfação do cliente 
            em todos os serviços que realizamos.
          </p>
        </motion.div>
        
        {/* Differentials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {diferenciais.map((item, index) => {
            const Icon = iconMap[item.icone] || Shield;
            
            return (
              <motion.div
                key={item.titulo}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex gap-4 p-6 bg-[#1A1A1A] border border-[#333] hover:border-[#FF6B00] hover:-translate-y-1 transition-all duration-300"
                data-testid={`differential-${index + 1}`}
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#FF6B00] flex items-center justify-center">
                    <Icon className="w-6 h-6 text-black" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">
                    {item.titulo}
                  </h3>
                  <p className="text-[#999] text-sm leading-relaxed">
                    {item.descricao}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
